<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent icono-titulo="fas fa-clipboard-list" texto-titulo="Editar lista"></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <form @submit.prevent="guardarLista()">
          <h4 class="text-focus mb-2">{{lista.descripcion}}</h4>
          <float-label label="Porcentaje %:" clase>
            <input
              v-model="lista.porcentaje"
              id="porcentaje"
              placeholder="Ingresar porcentaje..."
              type="text"
              inputmode="numeric"
              class="form-control"
              :class="(enviado && (!$v.lista.porcentaje.required || !$v.lista.porcentaje.decimal)) ? 'is-invalid' : ''"
            />
            <template v-slot:validation>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.lista.porcentaje.required"
              >Debe ingresar un porcentaje</div>
              <div
                class="invalid-feedback"
                v-if="enviado && !$v.lista.porcentaje.decimal"
              >Debe ingresar sólo números</div>
            </template>
          </float-label>
          <button class="mt-1 btn btn-info float-right">Guardar</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import BlockUI from "@/components/loaders/BlockUI";
import { required, decimal } from "vuelidate/lib/validators";
import FloatLabel from "@/components/layouts/FloatLabel";
import axios from "axios";
import Swal from "sweetalert2";
import Lista from "@/models/lista";
export default {
  name: "EditarLista",
  components: {
    TituloComponent,
    BlockUI,
    FloatLabel,
  },
  data() {
    return {
      lista: new Lista(null, "", null),
      loading: false,
      enviado: false,
    };
  },
  validations: {
    lista: {
      porcentaje: { required, decimal },
    },
  },
  mounted() {
    this.lista.id = this.$route.params.id;
    this.getLista();
  },
  methods: {
    getLista() {
      this.loading = true;
      axios
        .get("listas/" + this.lista.id)
        .then((res) => {
          if (res.data.success) {
            this.lista = res.data.lista;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: "Oopss..",
            text: `No se ha encontrado lista.`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    guardarLista() {
      this.enviado = true;
      this.loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        return false;
      }
      axios
        .put("/listas/" + this.lista.id, this.lista)
        .then((res) => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `${res.data.lista.descripcion} se editó con éxito.`,
            });
            this.$router.push({ name: "ListarListas" });
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`,
          });
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>